<template>
  <div>
    <vs-popup-info-new-ver
      :active.sync="popupConfigNew.isOpen"
      :popupConfigNew="popupConfigNew"
      :key="index"
      @closePopup="closeCheckoutPopup"
    ></vs-popup-info-new-ver>
    <vs-popup
      fullscreen
      title="Appointment Information"
      :active.sync="config.isActive"
      id="view-appointment-popup"
      @close="closePopup"
      :key="config.appointmentId"
    >
      <transition name="list">
        <div class="flex view-popup-content">
          <div
            class="lg:w-2/3 md:w-2/3 w-1/2 flex align-center flex-col overflow-auto"
          >
            <div class="w-11/12">
              <div class="flex align-center">
                <vs-chip
                  v-if="appointmentDetail.status !== undefined"
                  :color="statusColor(appointmentDetail.status)"
                  >{{ appointmentDetail.status.toUpperCase() }}</vs-chip
                >
                <vs-chip color="warning" class="ml-2" v-if="appointmentDetail.flag && appointmentDetail.flag == 'website'">website</vs-chip>
                <vs-chip color="warning" class="ml-2" v-if="appointmentDetail.flag && appointmentDetail.flag == 'website_new'">website v2</vs-chip>
                <vs-chip color="success" class="ml-2" v-if="isStripePaymentActive && appointmentDetail.deposit && appointmentDetail.deposit.amount">Deposited</vs-chip>
              </div>
              <div class="flex align-center justify-between w-full">
                <h3 class="font-light my-6 font-bold">
                  {{ appointmentDetail.date }}
                </h3>
                <!-- <vs-chip
                  v-if="appointmentDetail.status !== undefined"
                  :color="statusColor(appointmentDetail.status)"
                  class="mt-1"
                >{{appointmentDetail.status.toUpperCase()}}</vs-chip>-->
                <!-- <vs-button size="small" icon-pack="feather" icon="icon-edit" color="dark" class="gradient gradient-dark no-shadow rounded-full" @click="editAppointment()"></vs-button> -->
                <!-- <i class="material-icons ml-auto cursor-pointer gradient gradient-dark no-shadow text-white user-select-none popup-edit-edit-icon" @click="editAppointment()">create</i> -->

                <!-- <vs-button
                  v-if="appointmentDetail.status == 'scheduled'"
                  class="btn-calendar gradient gradient-success no-shadow"
                  @click="changeStatus('confirmed')"
                >Confirm</vs-button>-->
                <div class="flex items-center">
                  <vs-button class="btn-calendar gradient gradient-primary no-shadow mr-3" @click="copyAppointment">
                    Copy
                  </vs-button>
                  <vs-button
                    v-if="
                      appointmentDetail.status != 'done' &&
                      appointmentDetail.status != 'canceled' &&
                      appointmentDetail.service_booked &&
                      appointmentDetail.service_booked.length == 0
                    "
                    class="btn-calendar gradient gradient-primary no-shadow"
                    @click="editAppointment()"
                    style="padding: 0.75rem 2rem !important"
                  >
                    <i class="material-icons text-sm mr-1">create</i>Edit
                  </vs-button>
                </div>
              </div>

              <div class="mb-6 pb-5">
                <div class="vx-row mx-0 w-full" style="padding: 16px 0">
                  <div class="vx-col w-1/4 font-bold px-0">
                    {{ toAmPm(appointmentDetail.start_time) }} -
                    {{ toAmPm(appointmentDetail.end_time) }}
                  </div>
                  <div class="vx-col w-3/4 flex justify-between px-0">
                    <div>
                      <p
                        class="font-bold text-lg mb-2 p-0"
                        v-if="
                          appointmentDetail.service &&
                          appointmentDetail.service.name
                        "
                      >
                        {{ appointmentDetail.service.name }}
                      </p>
                      <p
                        class="text-sm pt-0"
                        v-if="
                          appointmentDetail.employee &&
                          appointmentDetail.employee.name
                        "
                      >
                        {{ appointmentDetail.duration.text }} with
                        {{ appointmentDetail.employee.name }}
                      </p>
                    </div>
                    <div class="font-bold text-lg">
                      <span>$</span>
                      <span>{{ appointmentDetail.price_final }}</span>
                    </div>
                  </div>
                </div>
                <!-- Additional -->
                <div
                  class="vx-row mx-0"
                  style="padding: 16px 0"
                  v-for="appointment in appointmentDetail.additional_appointments"
                  :key="appointment.id"
                >
                  <div class="vx-col w-1/4 font-bold px-0">
                    {{ toAmPm(appointment.start_time) }} -
                    {{ toAmPm(appointment.end_time) }}
                  </div>
                  <div class="vx-col w-3/4 flex justify-between px-0">
                    <div>
                      <p
                        class="font-bold text-lg mb-2"
                        v-if="appointment.service && appointment.service.name"
                      >
                        {{ appointment.service.name }}
                      </p>
                      <p
                        class="text-sm"
                        v-if="appointment.employee && appointment.employee.name"
                      >
                        {{ appointment.duration.text }} with
                        {{ appointment.employee.name }}
                      </p>
                    </div>
                    <div class="font-bold text-lg">
                      <span>$</span>
                      <span>{{ appointment.price_final }}</span>
                    </div>
                  </div>
                </div>

                <!-- Service booked old version -->
                <div
                  class="vx-row mx-0"
                  style="padding: 16px 0"
                  v-for="appointment in appointmentDetail.service_booked"
                  :key="appointment.id"
                >
                  <div class="vx-col w-1/4 font-bold px-0">
                    {{ toAmPm(appointmentDetail.start_time) }} -
                    {{ toAmPm(appointmentDetail.end_time) }}
                  </div>
                  <div class="vx-col w-3/4 flex justify-between px-0">
                    <div>
                      <p
                        class="font-bold text-lg mb-2"
                        v-if="appointment.service && appointment.service.name"
                      >
                        {{ appointment.service.name }}
                      </p>
                      <p
                        class="text-sm"
                        v-if="
                          appointment.service.duration &&
                          appointmentDetail.employee &&
                          appointmentDetail.employee.name
                        "
                      >
                        {{ appointment.service.duration }}m with
                        {{ appointmentDetail.employee.name }}
                      </p>
                    </div>
                    <div class="font-bold text-lg">
                      <span>$</span>
                      <span>{{
                        appointment.service.price
                          ? appointment.service.price
                          : 0
                      }}</span>
                    </div>
                  </div>
                </div>

                <vs-divider></vs-divider>

                <div class="vx-row mx-0">
                  <div class="vx-col w-1/4 font-bold text-lg px-0"></div>
                  <div class="vx-col w-3/4 flex justify-between px-0">
                    <div>
                      <p class="text-lg mb-2 font-normal">
                        {{ totalDuration }}
                      </p>
                    </div>
                    <div class="font-bold text-xl">
                      <span>$</span>
                      <span>{{ totalPrice }}</span>
                    </div>
                  </div>
                </div>
                <template v-if="isStripePaymentActive">
                  <template v-if="appointmentDetail.deposit">
                    <vs-divider></vs-divider>
                    <div class="flex items-center justify-between" >
                      <div class="font-bold">Deposit</div>
                      <div v-if="appointmentDetail.deposit.amount" class="text-right">
                        <!--                    <p>Amount: <span class="font-bold text-xl">+${{ appointmentDetail.deposit.amount / 100 }}</span></p>-->
                        <p class="mt-2">Balance: <span class="font-bold text-xl">+${{ appointmentDetail.deposit.balance / 100 }}</span></p>
                        <div class="flex items-center justify-end mt-2">
                          <vs-button
                            class="btn-calendar gradient gradient-primary no-shadow"
                            @click="openDepositDetailPopup()"
                          >Detail</vs-button>
                          <vs-button
                            class="btn-calendar gradient gradient-danger no-shadow ml-2"
                            @click="openDepositRefundPopup()"
                            :disabled="!appointmentDetail.deposit.amount || appointmentDetail.deposit.balance === 0"
                          >Refund</vs-button>
                        </div>
                      </div>
                      <div class="flex items-center" v-else>
                        <p class="mr-2">No deposit yet</p>
                        <vs-button
                          class="btn-calendar gradient gradient-primary no-shadow"
                          @click="openDepositDetailPopup()"
                        >Charge</vs-button>
                      </div>
                    </div>
                  </template>
                  <div class="text-right" v-else>
                    <vs-divider></vs-divider>
                    <vs-button color="primary" @click="handleAddCard">
                      Add card
                    </vs-button>
                  </div>
                </template>
              </div>
              <div class="mb-6">
                <ul class="centerx flex gap-x-8">
                  <li>
                    <vs-checkbox :disabled="true" v-model="JSON.parse(appointmentDetail.extra_data).request">Requested</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox :disabled="true" v-model="JSON.parse(appointmentDetail.extra_data).highlight">
                      <p class="flex items-center">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.0204 12.83L16.8004 11.61C16.5104 11.36 16.3404 10.99 16.3304 10.58C16.3104 10.13 16.4904 9.68 16.8204 9.35L18.0204 8.15C19.0604 7.11 19.4504 6.11 19.1204 5.32C18.8004 4.54 17.8104 4.11 16.3504 4.11H5.90039V3.25C5.90039 2.84 5.56039 2.5 5.15039 2.5C4.74039 2.5 4.40039 2.84 4.40039 3.25V21.75C4.40039 22.16 4.74039 22.5 5.15039 22.5C5.56039 22.5 5.90039 22.16 5.90039 21.75V16.87H16.3504C17.7904 16.87 18.7604 16.43 19.0904 15.64C19.4204 14.85 19.0404 13.86 18.0204 12.83Z"
                            fill="#FFD055"
                          />
                        </svg>
                        <span>Highlight</span>
                      </p>
                    </vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox :disabled="true" v-model="JSON.parse(appointmentDetail.extra_data).no_show">No-show</vs-checkbox>
                  </li>
                </ul>
              </div>
              <div class="appointment-history-detail">
                <p
                  class="text-xl font-medium mb-2 font-bold"
                  v-if="appointmentDetail.note"
                >
                  Appointment note
                </p>
                <p class="text-sm">{{ appointmentDetail.note }}</p>
                <br />
                <p
                  class="text-xl font-medium mb-2 font-bold"
                  @click="isShowHistory = !isShowHistory"
                >
                  Appointment History
                  <feather-icon
                    v-if="!isShowHistory"
                    icon="ChevronDownIcon"
                    svgClasses="h-6 w-6"
                    class="mr-3"
                    style="transform: translateY(5px)"
                  />
                  <feather-icon
                    v-else
                    icon="ChevronUpIcon"
                    svgClasses="h-6 w-6"
                    class="mr-3"
                    style="transform: translateY(5px)"
                  />
                </p>
                <p class="text-sm pt-0">
                  Booked at {{ appointmentDetail.created_at }}
                </p>
                <p
                  hidden
                  class="text-sm pt-0"
                  v-if="appointmentDetail.updated_at != ''"
                >
                  Last updated at {{ appointmentDetail.updated_at }}
                </p>
                <br />
                <div v-if="isShowHistory">
                  <li
                    v-for="history in appointmentDetail.history"
                    :key="history.id"
                    class="text-sm pt-0"
                  >
                    Appointment status is set to
                    <b>{{ history.type.toUpperCase() }}</b>
                    at {{ history.created_at }}
                    <span v-if="history.staff_name">
                      by
                      <b>{{ history.staff_name }}</b>
                    </span>
                  </li>
                </div>
              </div>
            </div>
          </div>

          <div class="lg:w-1/3 md:1/3 w-1/2 right-content">
            <div class="mini-scroll">
              <div class="flex flex-col align-center mb-3" style="height: 140px" v-if="appointmentDetail">
                <vs-avatar
                  v-if="appointmentDetail.customer"
                  :text="
                    StringHelper.changeFormatAvatar(
                      appointmentDetail.customer.full_name
                    )
                  "
                  size="55px"
                  class="m-3 mt-0 text-2xl"
                />
                <vs-avatar
                  v-else
                  :text="
                    StringHelper.changeFormatAvatar(appointmentDetail.booker_name)
                  "
                  size="55px"
                  class="m-3 mt-0 text-2xl"
                />
                <p class="font-bold text-lg p-0 color-black">
                  {{ appointmentDetail.booker_name }}
                </p>
                <!-- <p class="text-sm">{{appointmentDetail.customer.phone}}</p> -->
                <div class="flex text-sm mt-3">
                  <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                  <span v-if="appointmentDetail.customer && appointmentDetail.customer.phone">
                    {{ StringHelper.phoneNumberFormat(appointmentDetail.customer.phone, hide_phone) }}
                  </span>
                  <span v-else>
                    {{ StringHelper.phoneNumberFormat(appointmentDetail.booker_contact, hide_phone) }}
                  </span>
                </div>
                <p class="text-sm p-0" v-if="appointmentDetail.customer && appointmentDetail.customer.note">
                      <feather-icon
                        icon="ClipboardIcon"
                        svgClasses="h-4 w-4 mr-1 mt-1"
                      />
                      <span>{{ appointmentDetail.customer.note }}</span>
                    </p>
              </div>
              <!-- <vs-divider class="m-0 pl-4"></vs-divider> -->
              <!-- <div> -->
              <div
                :class="{
                  'appointment-done': appointmentDetail.status == 'done',
                }"
                class="overflow-auto view-appointment-tabs ml-4 border-bottom-custom"
              >
                <!-- <div class="flex flex-col align-center" v-if="appointmentDetail.status != 'done'">
                  <img src="../../assets/images/appointment/invoice.svg" class="svg-icon" />
                  <p class style="margin-bottom: 60px">No invoice issued yet</p>
                </div>
                <div class="flex flex-col align-center" v-else>
                  <img src="../../assets/images/appointment/invoice_done.svg" class="svg-icon" />
                  <p class style="margin-bottom: 60px">Appointment completed</p>
                </div>-->

                <appointment-tabs
                  v-if="appointmentDetail && appointmentDetail.customer"
                  :customerId="customerId"
                  :key="customerId"
                ></appointment-tabs>
              </div>
            </div>

            <!-- </div> -->
            <!-- <vs-divider class="m-0 p-0 pl-4"></vs-divider>  -->
            <div
              class="flex flex-col align-center pt-4 bg-white right-content-footer ml-4 mr-4"
            >
              <p class="pb-4 font-bold">
                Total:
                <span class="ml-1">$</span>

                <span v-if="totalPrice">{{ totalPrice }}</span>
                <span v-else>0</span>

                <span v-if="totalDuration" class="ml-1"
                  >({{ totalDuration }})</span
                >
                <span class="ml-1" v-else>(0m)</span>
              </p>

              <div
                class="vx-row w-full pr-4"
                v-if="
                  appointmentDetail.status != 'done' &&
                  appointmentDetail.status != 'canceled'
                "
              >
                <vs-button
                  v-if="appointmentDetail.status == 'scheduled'"
                  class="gradient gradient-success no-shadow vx-col w-custom mx-auto ml-0"
                  @click="changeStatus('confirmed')"
                  >CONFIRM APPOINTMENT</vs-button
                >
                <vs-button
                  type="border"
                  color="danger"
                  v-if="appointmentDetail.status == 'scheduled'"
                  class="vx-col w-custom mx-auto mr-0"
                  @click="changeStatus('canceled')"
                  >CANCEL APPOINTMENT</vs-button
                >
                <vs-button
                  type="border"
                  color="danger"
                  class="vx-col w-full mx-auto mr-0"
                  @click="changeStatus('canceled')"
                  v-if="appointmentDetail.status == 'confirmed'"
                  style="height: 42px"
                  >CANCEL APPOINTMENT</vs-button
                >
                <!-- <vs-dropdown
                  vs-trigger-click
                  class="cursor-pointer item-per-page-dropdown vx-col w-custom ml-auto pr-0"
                  :class="{'w-full pl-0': appointmentDetail.status != 'scheduled'}"
                >
                  <div
                    class="px-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-center font-medium shadow-md"
                  >
                    <span
                      class="font-bold sm:text-xs text-sm xl:px-5 px-0"
                      v-if="appointmentDetail.status"
                    >{{appointmentDetail.status.toUpperCase()}}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu class="dropdown-appointment">
                    <vs-dropdown-item
                      v-if="appointmentDetail.status != 'scheduled'"
                      @click="changeStatus('scheduled')"
                    >
                      <span>SCHEDULED</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="appointmentDetail.status != 'confirmed'"
                      @click="changeStatus('confirmed')"
                    >
                      <span>CONFIRMED</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="appointmentDetail.status != 'canceled'"
                      @click="changeStatus('canceled')"
                    >
                      <span class="text-danger">CANCEL</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>-->

                <vs-button
                  color="primary"
                  type="filled"
                  class="gradient gradient-primary font-bold sm:text-xs text-sm shadow-md vx-col w-full mt-4"
                  @click="openCheckout"
                  style="height: 42px"
                  v-if="
                    appointmentDetail.checkin_available == true &&
                    type != 'auto'
                  "
                  >EXPRESS CHECKOUT</vs-button
                >

                <vs-button
                  color="primary"
                  type="filled"
                  class="gradient gradient-primary font-bold shadow-md vx-col w-full mt-4"
                  @click="doneAppointment"
                  v-if="
                    appointmentDetail.checkin_available == false ||
                    type == 'auto'
                  "
                  style="height: 42px"
                  :disabled="!doneable"
                  >DONE APPOINTMENT</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </transition>

      <div>
        <transition name="list">
          <!-- <vs-checkout
          :appointmentDetail="appointmentDetail"
          v-show="openCheckout"
          :key="appointmentDetail.id"
          v-if="openCheckout"
          ></vs-checkout>-->
        </transition>
        <vs-prompt
          @accept="acceptAlert"
          :active.sync="activePrompt"
          accept-text="Confirm"
          color="danger"
          title="Confirmation"
        >
          <div class="con-exemple-prompt">
            Are you sure to cancel this appointment?
          </div>
        </vs-prompt>
      </div>
    </vs-popup>

    <refund-popup
      :refundPopupConfig="refundPopupConfig"
      :key="'refund-' + refund_key"
      @GetData="reload">
    </refund-popup>

    <deposit-detail-popup
      :depositDetailPopup="depositDetailPopup"
      @OpenOrderPopup="openOrderPopup"
      :key="'deposit-detail-' + depositDetailKey"
      @changeSuccess="reload"
      is-from-appointment
    ></deposit-detail-popup>

    <vs-popup-order-detail
      :popupOrderDetail="orderDetailConfig"
      :active_id="order_id" :key="'order-detail-' + order_key"
      @ClosePopup="closeOrderPopup"
      v-if="order_id != null">
    </vs-popup-order-detail>

    <add-card-popup ref="addCardPopupRef" @success="reload"></add-card-popup>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { StringHelper } from "../../models/string_helper";
import moment from "moment";
import DepositDetailPopup from "../../components/apppointment/DepositDetailPopup.vue";
import RefundPopup from "../../components/apppointment/RefundPopup.vue";
import AddCardPopup from "./AddCardPopup.vue";
export default {
  name: "appointment-popup",
  components: {
    RefundPopup,
    DepositDetailPopup,
    Datepicker,
    AddCardPopup,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if (this.config.isActive) {
          document.body.classList.add("overflow-hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      },
    },
    appointmentDetail: {
      immediate: true,
      deep: true,
      handler() {
        if (this.appointmentDetail && this.appointmentDetail.customer) {
          this.customerId = this.appointmentDetail.customer.id;
        }
      },
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    closeCheckoutPopup() {
      (this.popupConfigNew.isOpen = false), this.doneAppointment();
    },
    editAppointment() {
      this.$emit("edit", this.appointmentDetail.id);
    },
    copyAppointment() {
      this.$emit("copy", this.appointmentDetail.id);
    },
    changeStatus(status) {
      if (status == "canceled") {
        this.activePrompt = true;
      } else {
        let form = {
          id: this.appointmentDetail.id,
          status: status,
        };
        this.$store
          .dispatch("appointment/UPDATE_STATUS", form)
          .then(async () => {
            await this.$store.dispatch("appointment/GET_APPOINTMENT_DETAIL", {
              id: this.appointmentDetail.id,
            });
            await this.$vs.notify({
              title: "Success",
              text:
                "Appointment status is updated to " +
                status.toUpperCase() +
                "!",
              color: "success",
              position: "top-left",
            });
            // this.closePopup();
          });
      }
    },
    doneAppointment() {
      let form = {
        id: this.appointmentDetail.id,
        status: "done",
      };
      this.$store.dispatch("appointment/UPDATE_STATUS", form).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Checkout appointment successfully!",
          color: "success",
          position: "top-left",
        });
        this.closePopup();
      });
    },
    openCheckout() {
      this.index++;
      this.config.isActive = false;
      // if (this.type == "auto") {
      //   this.popupConfig = {
      //     isOpen: true,
      //     item_info: this.appointmentDetail.checkin,
      //     fromAppointment: true
      //   };
      // } else {
      this.popupConfigNew = {
        isOpen: true,
        item_info: this.appointmentDetail.checkin,
        fromAppointment: true,
      };
      // }
    },
    toAmPm(data) {
      if (data !== undefined) {
        let hours = parseInt(data.split(":")[0]);
        let minutes = parseInt(data.split(":")[1]);
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let start_text = hours + ":" + minutes + " " + ampm;
        return start_text;
      }
    },
    statusColor(status) {
      switch (status) {
        case "confirmed":
          return "#6610f2";
        case "scheduled":
          return "#007bff";
        case "delay":
          return "#fd7e14";
        case "done":
          return "#28a745";
        case "canceled":
          return "#DC3546";
      }
    },
    acceptAlert() {
      let form = {
        id: this.appointmentDetail.id,
        status: "canceled",
      };
      this.$store.dispatch("appointment/UPDATE_STATUS", form).then(() => {
        this.$vs.notify({
          title: "Success",
          text: "Cancel appointment successfully!",
          color: "success",
          position: "top-left",
        });
        this.closePopup();
      });
    },
    async reload() {
      try {
        await this.$store.dispatch("appointment/GET_APPOINTMENT_DETAIL", {
          id: this.appointmentDetail.id,
        });
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          color:'danger',
        });
      }
    },
    openOrderPopup(id) {
      this.orderDetailConfig.isOpen = true;
      this.order_id = id;
      this.order_key++;
    },
    closeOrderPopup() {
      this.orderDetailConfig.isOpen = false;
    },
    async openDepositDetailPopup() {
      try {
        await this.$store.dispatch("appointment/GET_DEPOSIT_DETAIL", {
          id: this.appointmentDetail.deposit.id,
        });
        this.depositDetailKey++;
        this.depositDetailPopup.isOpen = true;
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          color:'danger',
        });
      }
    },
    openDepositRefundPopup() {
      this.refundPopupConfig.item_info = this.appointmentDetail.deposit;
      this.refundPopupConfig.isOpen = true;
      this.refund_key++;
    },
    handleAddCard() {
      this.$refs.addCardPopupRef.show()
    }
  },
  computed: {
    hide_phone() {
      let data = this.$store.getters["auth/config"];
      if(data && data.hide_customer_number_on_calendar == 1) {
        return true;
      }
      return false;
    },
    appointmentDetail() {
      return this.$store.getters["appointment/appointmentDetail"];
    },
    totalPrice() {
      let total = 0;
      if (this.appointmentDetail.service) {
        let temp_price = parseInt(this.appointmentDetail.service.price);
        if (!isNaN(temp_price)) {
          total += temp_price;
        }
      }
      if (this.appointmentDetail.additional_appointments) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          if (this.appointmentDetail.additional_appointments[i].service) {
            let temp_price = parseInt(
              this.appointmentDetail.additional_appointments[i].service.price
            );
            if (!isNaN(temp_price)) {
              total += temp_price;
            }
          }
        }
      }
      return total;
    },
    totalDuration() {
      let total = 0;
      if (this.appointmentDetail.duration) {
        let temp_duration = parseInt(this.appointmentDetail.duration.value);
        if (!isNaN(temp_duration)) {
          total += temp_duration;
        }
      }
      if (this.appointmentDetail.additional_appointments) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          if (this.appointmentDetail.additional_appointments[i].duration) {
            let temp_duration = parseInt(
              this.appointmentDetail.additional_appointments[i].duration.value
            );
            if (!isNaN(temp_duration)) {
              total += temp_duration;
            }
          }
        }
      }
      let hours = Math.floor(total / 60);
      let minutes = total % 60;
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    },
    authConfig() {
      return this.$store.getters["auth/config"];
    },
    isStripePaymentActive() {
      return this.authConfig.stripe_setup_payment_active == '1'
    }
  },
  data() {
    return {
      customerId: null,
      StringHelper,
      index: this.config.appointmentId + 1000,
      activePrompt: false,
      isShowHistory: false,
      popupConfigNew: {
        isOpen: false,
        item_info: {},
      },
      popupConfig: {
        isOpen: false,
        item_info: {},
      },
      type: "",
      doneable: true,
      // checkout_key: 0,
      depositDetailPopup: {
        isOpen: false
      },
      orderDetailConfig: {
        isOpen: false
      },
      order_id: null,
      order_key: 0,
      depositDetailKey: 0,
      refundPopupConfig: {
        isOpen: false,
        item_info: null
      },
      refund_key: 0,
    };
  },
  created() {
    if (
      typeof this.appointmentDetail !== "undefined" &&
      Object.keys(this.appointmentDetail).length > 0
    ) {
      let appointmentEndTime = this.appointmentDetail.end_time;
      let appointmentEndDate = this.appointmentDetail.date;
      if (
        typeof this.appointmentDetail.additional_appointments !== "undefined" &&
        this.appointmentDetail.additional_appointments
      ) {
        for (
          let i = 0;
          i < this.appointmentDetail.additional_appointments.length;
          i++
        ) {
          appointmentEndTime = this.appointmentDetail.additional_appointments[i]
            .end_time;
          appointmentEndDate = this.appointmentDetail.additional_appointments[i]
            .date;
        }
      }
      if (
        typeof appointmentEndDate !== "undefined" &&
        typeof appointmentEndTime !== "undefined"
      ) {
        this.doneable = moment().isAfter(
          appointmentEndDate + " " + appointmentEndTime
        );
      }
    }
    this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
      let data = {};
      data = this.$store.state.appSetting.checkoutConfig;
      this.type = data.type;
    });
  },
};
</script>

<style lang="scss">
.con-vs-popup.deposit-detail-popup{
  z-index: 53001 !important;
}
</style>
